import { getNameList } from 'country-list';
import { IDesignations } from '../redux/user/userSlice';

export const countries = Object.entries(getNameList())
  .map((country) => ({
    label: country[0].charAt(0).toUpperCase() + country[0].slice(1),
    value: country[0],
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const mapDesignations = (designations: IDesignations[]) =>
  designations.map((designation) => ({
    label: designation.designation,
    value: designation.id.toString(),
  }));
